import { render, staticRenderFns } from "./DirectoryAccountsPageView.vue?vue&type=template&id=2df4d648&"
import script from "./DirectoryAccountsPageView.vue?vue&type=script&lang=js&"
export * from "./DirectoryAccountsPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports